interface IconProps extends React.SVGProps<SVGSVGElement> {}

export const Ripple = ({ ...props }: IconProps) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_188_26627)">
      <circle
        cx="50"
        cy="50"
        r="50"
        fill="url(#paint0_linear_188_26627)"
      />
      <path
        d="M71.2921 25L57.5383 38.6069C55.5297 40.5909 52.823 41.7054 50 41.7054C47.177 41.7054 44.4703 40.5909 42.4617 38.6069L28.7079 25H20L38.1323 42.9486C41.2799 46.0594 45.5236 47.8108 49.951 47.8108H50.049C54.4764 47.8108 58.7201 46.0655 61.8677 42.9486L80 25H71.2921Z"
        fill="white"
      />
      <path
        d="M71.2921 74.7612L57.5383 61.1543C55.5297 59.1702 52.823 58.0557 50 58.0557C47.177 58.0557 44.4703 59.1702 42.4617 61.1543L28.7079 74.7612H20L38.1323 56.8126C41.2799 53.7018 45.5236 51.9504 49.951 51.9504H50.049C54.4764 51.9504 58.7201 53.6956 61.8677 56.8126L80 74.7612H71.2921Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_188_26627"
        x1="0"
        y1="50"
        x2="100"
        y2="50"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#60499C" />
        <stop
          offset="1"
          stopColor="#476DB5"
        />
      </linearGradient>
      <clipPath id="clip0_188_26627">
        <rect
          width="100"
          height="100"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
